import { Field } from "formik";
import React, { useState, useRef ,useEffect} from "react";

const TextAreaInput = ({
  name,
  value,
  handleChange,
  placeholder,
  isDisabled = false,
  bgColor = "bg-gray-50",
  classes = "",
  rows = 4,
  legend = false
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const textareaRef = useRef(null);

  const handleFieldsetClick = () => {
    if (!isFocused && !value) {
      textareaRef.current.focus();
    }
  };
   useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto"; // reset height
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // set to scroll height
    }
  }, [value]);

  return legend ? (
    <fieldset
      className={`relative border ${isFocused ? "border-[#D1D1D1]" : "border-[#D1D1D1]"} rounded-[4px] w-full px-2 h-10 flex items-center bg-white`}
      onClick={handleFieldsetClick}
    >
      <legend
        className={`absolute left-2 transition-all duration-200 ${bgColor} px-1 ${
          isFocused || value
            ? "-top-3 text-sm text-[#201F1E]"
            : "top-3 text-sm text-[#656464]"
        }`}
      >
        {placeholder}
      </legend>

      <Field
        as="textarea"
        name={name}
        value={value}
        onChange={handleChange}
        disabled={isDisabled}
        rows={rows}
        className={`${classes} w-full border-none outline-none bg-transparent resize-none pt-1 px-2 h-12`}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        innerRef={textareaRef}
      />
    </fieldset>
  ) : (
    <Field
      as="textarea"
      name={name}
      value={value}
      onChange={handleChange}
      disabled={isDisabled}
      rows={rows}
      placeholder={placeholder}
      className={`${classes} w-64 border border-gray-300 rounded-[0.3rem] p-2 resize-none`}
    />
  );
};

export default TextAreaInput;
